import React from "react";
import Pie from "./Pie";
import Empty from "../Empty";

class Series extends React.Component {
  componentDidMount() {}

  render() {
    const {
      data: { seriesData, title },
    } = this.props;
    return (
      <div>
        {seriesData.length > 0 ? (
          <Pie {...this.props} />
        ) : (
          <Empty title={title} />
        )}
      </div>
    );
  }
}

export default Series;



// WEBPACK FOOTER //
// ./src/components/comm/charts/Pie2/Index.js